import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/api';

export interface FeedVenue {
  id: string;
  name: string;
  slug: string;
  logoUrl: string | null;
  coverImageUrl: string | null;
  restaurantCount: number;
  distanceKm: number | null;
}

interface Params {
  lat?: number | null;
  lng?: number | null;
  limit?: number;
  enabled?: boolean;
}

export function useNearbyVenues({ lat, lng, limit = 10, enabled = true }: Params) {
  const [items, setItems] = useState<FeedVenue[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    const ac = new AbortController();
    setLoading(true);
    const params: Record<string, string | number> = { limit };
    if (lat != null && lng != null) {
      params.lat = lat;
      params.lng = lng;
    }
    axios
      .get<{ items: FeedVenue[] }>(`${API_URL || ''}/api/feed/venues`, { params, signal: ac.signal })
      .then((r) => setItems(r.data.items || []))
      .catch(() => { /* silent */ })
      .finally(() => setLoading(false));
    return () => ac.abort();
  }, [lat, lng, limit, enabled]);

  return { items, loading };
}
